module.exports = __webpack_public_path__ + "static/L2_ux_3_2_eg-3428d3d2cecdced335de0a73e7c538ac.png";